//import axios from 'axios';

import lib from "@/lib";

export default class AppModel {
	/**
	 * Конструктор
	 */
	constructor() {
		this.groups = lib.localStorageGet("groups") || [];
	}

	pageReload() {
		document.location.reload();
	}

	/**
	 * Принудительное сохранение данных
	 *
	 * @returns array status
	 */
	doDataSave() {
		lib.localStorageSet("groups", this.groups, false);

		return {
			success: true,
			error: "",
		};
	}

	/**
	 * Полный сброс данных
	 *
	 * @returns array status
	 */
	doDataClear() {
		this.groups = [];
		lib.localStorageSet("groups", this.groups, false);

		return {
			success: true,
			error: "",
		};
	}

	/**
	 * Добавление группы
	 *
	 * @param {object} data массив данных для добавления
	 * @returns array status
	 */
	doGroupAdd(data) {
		if (this.groups.findIndex((el) => el.name == data.name) !== -1) {
			return {
				success: false,
				error: "Группа с таким названием уже существует",
			};
		}

		this.groups.push({
			id: lib.genId(),
			name: data.name.trim() || "Новая группа",
			items: [],
		});

		lib.localStorageSet("groups", this.groups, false);

		return {
			success: true,
			error: "",
		};
	}

	/**
	 * Изменение группы
	 *
	 * @param {number} group_id id группы
	 * @param {object} data массив данных для изменения
	 * @returns array status
	 */
	doGroupEdit(group_id, data) {
		let group = this.groups.find((group) => group.id == group_id);

		group.name = data.name.trim() || group.name;

		lib.localStorageSet("groups", this.groups, false);

		return {
			success: true,
			error: "",
		};
	}

	/**
	 * Удаление группы
	 *
	 * @param {number} group_id id группы
	 * @returns array status
	 */
	doGroupDelete(group_id) {
		let group_index = this.groups.findIndex(
			(group) => group.id == group_id,
		);

		this.groups.splice(group_index, 1);

		lib.localStorageSet("groups", this.groups, false);

		return {
			success: true,
			error: "",
		};
	}

	/**
	 * Добавление элемента в группу
	 *
	 * @param {number} group_id id группы
	 * @param {object} data массив данных для добавления
	 * @returns array status
	 */
	doElementAdd(group_id, data) {
		let group = this.groups.find((group) => group.id == group_id);

		if (group.items.length > 0) {
			if (group.items.findIndex((el) => el.name == data.name) !== -1) {
				return {
					success: false,
					error: "Элемент с таким названием уже существует",
				};
			}
		}

		group.items.push({
			id: lib.genId(),
			name: data.name.trim() || "Новый элемент",
			count: data.count.trim() || "",
			checked: false,
		});

		lib.localStorageSet("groups", this.groups, false);

		return {
			success: true,
			error: "",
		};
	}

	/**
	 * Изменение элемента группы
	 *
	 * @param {number} group_id id группы
	 * @param {number} element_id id элемента
	 * @param {object} data массив данных для изменения
	 * @returns array status
	 */
	doElementEdit(group_id, element_id, data) {
		let group = this.groups.find((group) => group.id == group_id);
		let element = group.items.find((el) => el.id == element_id);

		element.name = data.name.trim() || element.name;
		element.count = data.count.trim() || element.count;

		lib.localStorageSet("groups", this.groups, false);

		return {
			success: true,
			error: "",
		};
	}

	/**
	 * Удаление элемента группы
	 *
	 * @param {number} group_id id группы
	 * @param {number} element_id id элемента
	 * @returns array status
	 */
	doElementDelete(group_id, element_id) {
		let group = this.groups.find((group) => group.id == group_id);
		let element_index = group.items.findIndex((el) => el.id == element_id);

		group.items.splice(element_index, 1);

		lib.localStorageSet("groups", this.groups, false);

		return {
			success: true,
			error: "",
		};
	}

	/**
	 * Изменение свойства checked элемента группы
	 *
	 * @returns array status
	 */
	doElementCheckedToggle() {
		lib.localStorageSet("groups", this.groups, false);

		return {
			success: true,
			error: "",
		};
	}
}
